import { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";

export default function CustomDropdownDays({
  defaultSelected = "Last 7 days",
  options = ["Last week", "Last month"],
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(defaultSelected);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
  };

  return (
    <div
      className={classNames(styles.dropdown, { [styles.active]: isOpen })}
      ref={dropdownRef}
    >
      <button
        className={classNames(styles.dropdownBtn, { [styles.active]: isOpen })}
        onClick={toggleDropdown}
      >
        {selected}
        <span
          className={classNames(styles.caret, { [styles.caretOpen]: isOpen })}
        ></span>
      </button>
      {isOpen && (
        <div className={styles.dropdownContent}>
          {options.map((option, index) => (
            <p key={index} onClick={() => handleSelect(option)}>
              {option}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}
